import { createSelector } from 'reselect';

const selector = state => state.products;

export const productsSelector = createSelector(
  selector,
  pickUps => pickUps.products
);
